import React, { useState, useCallback } from 'react';
import Gallery from 'react-photo-gallery';
import Carousel, { Modal, ModalGateway } from 'react-images';
import Container from 'react-bootstrap/esm/Container';
import './EngagementGalleryView.css';
import EngagementPhotos from '../components/EngagementPhotos';

const EngagementGalleryView = (props: any) => {
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = useCallback((event, { photo, index }) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    }, []);

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    return (
        <div>
            <Container className="engagement-gallery">
                <br />
                <h1 className="engagement-gallery-header">Engagement Gallery</h1>
                <br />
            </Container>
            <Gallery direction='column' photos={EngagementPhotos} onClick={openLightbox} />
            <ModalGateway>
                {viewerIsOpen ? (
                    <Modal onClose={closeLightbox}>
                        <Carousel
                            currentIndex={currentImage}
                            views={EngagementPhotos.map(x => ({
                                ...x,
                                source: x.src,
                                caption: x.caption
                            }))}
                        />
                    </Modal>
                ) : null}
            </ModalGateway>
        </div>
    );
}

export default EngagementGalleryView;